- icon: google-scholar
  name: Google Scholar
  url: https://scholar.google.com/citations?user=4dFSWwMAAAAJ
- icon: dblp
  name: DBLP
  url: https://dblp.org/pid/234/9130-1.html
- icon: orcid
  name: ORCID
  url: https://orcid.org/0000-0002-9491-7367
- icon: semantic-scholar
  name: Semantic Scholar
  url: https://www.semanticscholar.org/author/Keisuke-Okumura/20433747
- icon: researchgate
  name: Research Gate
  url: https://www.researchgate.net/profile/Keisuke_Okumura
- icon: arxiv
  name: arXiv
  url: https://arxiv.org/search/?query=Keisuke+Okumura&searchtype=author
